import Backbone from 'backbone'
import template from './budget.hbs'
import _ from 'lodash'
import nonAbbreviatedValuesTooltip from 'scoreboard/components/non-abbreviated-values-tooltip.hbs'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import { getBudgetStatusIconAndColor } from '../status-icon-and-color'

var Budget = Backbone.View.extend({

	// this.model is an Initiative
	className: 'panel icon-panel',

	/**
	 * options.model is the Initiative
	 * options.fullContext is populated from model.context()
	 */
	initialize: function(options) {
		this.options = options || {}
		this.model.on('change:projectedBudget', this.render.bind(this))
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		var status = _.result(this.model.get('projectedBudget'), 'status')
		this.$el.toggleClass('has-no-status-data', status === 'no-data')

		this.tooltips = new TooltipAndDetails({
			el: this.el,
			selector: '[data-unshortened-value]',
			tooltipContent: e => nonAbbreviatedValuesTooltip({
				header: e.target.dataset.unshortenedHeader,
				value: e.target.dataset.unshortenedValue
			}),
			tooltipOptions: {
				extraClass: 'tooltip-and-details non-abbreviated-tooltip initiatives-overview-budget-non-abbreviated-tooltip',
				placement: 'above'
			}
		})
		return this
	},

	context: function() {
		// all the stuff below only make sense if there is a projected budget
		if (!this.model.get('projectedBudget')) {
			return this.model.attributes
		}
		var fullContext = this.options.fullContext
		var completionSuffix = this.model.get('aggregatedCompletionDate') ? '.completed' : ''
		let ctx = _.extend({}, this.model.attributes, {
			headerLabel: 'initiatives.projectedBudget' + completionSuffix,
			totalLabel: 'initiatives.projectedTotal' + completionSuffix,
			varianceLabel: 'initiatives.variance' + completionSuffix,
			absolutePercentUnder: fullContext.value('initiatives.projected.Pct'),
			absolutePercentUnderUnshortened: fullContext.value('initiatives.projected.PctUnshortened'),
			absoluteAmountUnder: fullContext.value('initiatives.projected.Amt'),
			absoluteAmountUnderUnshortened: fullContext.value('initiatives.projected.AmtUnshortened'),
			projectedTotal: fullContext.value('initiatives.projectedTotal'),
			projectedTotalUnshortened: fullContext.value('initiatives.projectedTotalUnshortened')
		})

		if (this.model.get('projectedBudget').status === 'no-data') {
			ctx.projectedBudget.descriptiveMessageCode = 'initiatives.projectedBudget.noData'
			ctx.projectedBudgetMessageCode = 'initiatives.projectedBudget.noData'
		} else {
			// #56069 #54952 use the sentence cased version of the message for display here
			// but don't mutate ctx.projectedBudget.descriptiveMessageCode, since it is used
			// in initiatives-overview-info.js
			ctx.projectedBudgetMessageCode = ctx.projectedBudget.descriptiveMessageCode + '.sentenceCase'
		}

		_.extend(ctx, getBudgetStatusIconAndColor(this.model))

		return ctx
	}
})

export default Budget

Budget.__filename__ = 'initiatives/overview/budget.js'
